import React, { LegacyRef } from 'react';

import {
  getLogoTitle,
  getTelTitle,
  getTelNummber,
  getTelNummberLink,
  getHeaderInjection,
} from './overrides';

import './index.scss';
import { replaceAllComplex } from '../../../../../../mol_function';
import MolLink from '../Menu/MolLink';

interface HeaderMolunaProps {
  domainPrefix: string;
  articleCount: number;
  articlePreis: string;
  isLogin: boolean;
  showSearch: boolean;
}

export default class HeaderMoluna extends React.Component<HeaderMolunaProps> {
  safeRef: LegacyRef<HTMLLIElement> | undefined;

  constructor(props: any) {
    super(props);
    this.safeRef = React.createRef();
  }

  componentDidMount() {
    let ref: any = this.safeRef;
    ref.current.style.display = 'none';
  }

  render() {
    let createLiButton = (
      linkHref: string,
      linkTitle: string,
      imgId: string,
      labelText: string,
    ) => {
      return (
        <li>
          <a href={linkHref} title={linkTitle}>
            <div>
              <img
                id={imgId}
                src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
              />
              <span>{labelText}</span>
            </div>
          </a>
        </li>
      );
    };

    let link_kontakt = (child: JSX.Element) => {
      return (
        <a
          href={this.props.domainPrefix + '/index.php?main_page=contact_us'}
          title={getTelTitle()}
        >
          {child}
        </a>
      );
    };

    let link_konto = (child: JSX.Element) => {
      return (
        <a
          href={this.props.domainPrefix + '/index.php?main_page=account'}
          title={'Login/Logout'}
        >
          {child}
        </a>
      );
    };

    let link_warenkorb = (child: JSX.Element) => {
      return (
        <a
          href={this.props.domainPrefix + '/index.php?main_page=shopping_cart'}
          title={'Mein Warenkorb'}
        >
          {child}
        </a>
      );
    };

    return (
      <React.Fragment>
        <div id="headermoluna">
          <div id="logoContainer">
            <MolLink to="/" href={this.props.domainPrefix}>
              <div id="logo" title={getLogoTitle()}></div>
            </MolLink>
          </div>
          <div id="subheadermoluna">
            {this.props.showSearch ? (
              <div id="navMainSearch">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    let searchValue = $('#autosearch').val();
                    setTimeout(() => {
                      $('.ui-autocomplete.ui-menu').hide();
                      $('#autosearch').val('');
                      setTimeout(() => {
                        $('.ui-autocomplete.ui-menu').hide();
                      }, 1000);
                    }, 500);

                    searchValue = replaceAllComplex(searchValue, [
                      { s: ' ', r: '+' },
                      { s: '&', r: '%26' },
                    ]);

                    searchValue = encodeURI(searchValue);

                    window.historyHelper.memory.push(
                      '/search_page/?keyword=' + searchValue,
                      null,
                    );
                    return false;
                  }}
                >
                  <input
                    type="hidden"
                    name="main_page"
                    value="advanced_search_result"
                  ></input>
                  <input
                    type="hidden"
                    name="search_in_description"
                    value="1"
                  ></input>
                  <input
                    type="text"
                    name="keyword"
                    size={18}
                    maxLength={100}
                    className="search-header-box"
                    id="autosearch"
                    title="Suchbegriff oder ISBN Nr. (z.B. 978-3-551-55900-5) eingeben"
                    placeholder="Suchen"
                    defaultValue=""
                  ></input>
                  <input
                    style={{ display: 'none' }}
                    className="cssButton submit_button button  button_search"
                    type="submit"
                    value="Suche"
                    onMouseOver={(e) => {
                      let input: any = e.target;
                      if (input != null)
                        input.className =
                          'cssButtonHover  button_search button_searchHover';
                    }}
                    onMouseOut={(e) => {
                      let input: any = e.target;
                      if (input != null)
                        input.className =
                          'cssButton submit_button button  button_search';
                    }}
                  ></input>
                </form>
              </div>
            ) : null}{' '}
          </div>
          <div id="navMain">
            <table>
              <tbody>
                <tr>
                  <td rowSpan={2} className="safe" ref={this.safeRef}>
                    <div>
                      <div
                        style={{
                          width: 16,
                          height: 16,
                          marginRight: 10,
                        }}
                      >
                        <img
                          src="favicon.ico"
                          style={{ width: '100%', height: '100%' }}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    {link_kontakt(
                      <>
                        <img
                          id="ButtonsTel"
                          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                        />
                        <span className="mobileVersion">Kontakt</span>
                      </>,
                    )}
                  </td>
                  <td>
                    {link_konto(
                      <>
                        <img
                          id="ButtonsLogin"
                          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                        />
                        <span className="mobileVersion">Mein Konto</span>
                      </>,
                    )}
                  </td>
                  <td>
                    {link_warenkorb(
                      <>
                        <img
                          id="ButtonsBacket"
                          src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                        />
                        <span className="mobileVersion">
                          {this.props.articleCount > 0
                            ? this.props.articleCount + ' Artikel'
                            : 'Warenkorb'}
                        </span>
                      </>,
                    )}
                  </td>
                  <td rowSpan={2}>
                    {link_warenkorb(
                      <span
                        style={{ whiteSpace: 'nowrap', marginLeft: 'auto' }}
                      >
                        {this.props.articlePreis}
                      </span>,
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {link_kontakt(
                      <span className="desktopVersion">Kontakt</span>,
                    )}
                  </td>
                  <td>
                    {link_konto(
                      <span className="desktopVersion">Mein Konto</span>,
                    )}
                  </td>
                  <td>
                    {link_warenkorb(
                      <span className="desktopVersion">
                        {this.props.articleCount > 0
                          ? this.props.articleCount + ' Artikel'
                          : 'Warenkorb'}
                      </span>,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
